// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b14a56bf","488":"292d4ea1","977":"279cc6ee"}[chunkId] + ".chunk.js";
};